import React, { useCallback, useMemo } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { GetStudyResponse } from '@core/types';

dayjs.extend(utc);

function transformDicomAge(age: string) {
  // Expresión regular para verificar el formato: 0[YY]Y
  const regex = /^0(\d{2,3})Y$/;

  // Verificar si el string coincide con el formato esperado
  const match = age.match(regex);

  if (match) {
    // Extraer el valor numérico y convertirlo a número
    const edad = parseInt(match[1], 10);

    // Agregar ' Años' al valor numérico y retornar
    return edad + ' Años';
  } else {
    // Si no coincide con el formato esperado, devolver el mismo string
    return age;
  }
}

const getFormattedDate = (studyDate?: string) => {
  if (!studyDate) return '';

  const date = dayjs.utc(studyDate);
  if (!date.isValid()) return studyDate; // Check for invalid date

  const formattedDate = date.local().format('DD/MM/YYYY');

  return formattedDate;
};

const useGetDicomTemplateTagsInfo = ({ study }: { study?: GetStudyResponse }) => {
  const dicomAttributes: Record<string, string> = useMemo(
    () => ({
      Paciente_Nombre: study?.patientsFirstName || '',
      Paciente_Apellido: study?.patientsLastName || '',
      Paciente_FechaDeNacimiento: getFormattedDate(study?.patientsBirthDate || ''),
      Paciente_Genero: study?.patientsGender || '',
      Paciente_Edad: study?.patientsAge ? transformDicomAge(study?.patientsAge) : '',
      Estudio_Nombre: study?.studyDescription || '',
      Estudio_Fecha: getFormattedDate(study?.studyDate),
      Doctor: study?.referringPhysiciansName || '',
    }),
    [study],
  );

  return useCallback(
    (dicomKey: string) => {
      return dicomAttributes[dicomKey];
    },
    [dicomAttributes],
  );
};

export default useGetDicomTemplateTagsInfo;
